import { PushNotificationsError } from '../utils/error';
import { ERRORS } from '../settings';

export function checkNotificationPermission() {
  const { permission } = Notification;
  return new Promise((resolve, reject) => {
    switch (permission) {
      case 'granted':
        resolve(permission);
        break;

      case 'denied':
        reject(new PushNotificationsError(ERRORS.PERMISSION_DENIED));
        break;

      case 'default':
        resolve(permission);
        break;

      default:
        resolve(permission);
        break;
    }
  });
}

export function requestNotificationPermission(args: ServiceWorkerRegistration) {
  return new Promise<ServiceWorkerRegistration>((resolve, reject) => {
    if (Notification.permission === 'granted') {
      resolve(args);
    } else {
      void Notification.requestPermission((permission) => {
        if (permission === 'granted') {
          resolve(args);
        } else {
          reject(new PushNotificationsError(ERRORS.PERMISSION_DENIED));
        }
      });
    }
  });
}
